<ng-container *ngIf="contentlet$ | async as contentlet">
  <div class="card-body">
    <div class="accordion-shadow">
      <ngb-accordion
        #accordion="ngbAccordion"
        [destroyOnHide]="false"
        [closeOthers]="true"
        (panelChange)="panelShadow($event, shadow)"
        #shadow
        [animation]="false"
      >
        <ngb-panel [id]="this.panelId">
          <ng-template ngbPanelTitle>
            <div class="accordion-header">
              <p
                dotCmsSetAttributes
                [mode]="'full'"
                [fieldName]="'question'"
                [identifier]="contentlet.identifier"
                [innerHTML]="contentlet.question"
              ></p>
              <span class="faq-icon position-absolute">
                <i
                  [ngClass]="{
                    open: accordion.activeIds.includes('panel-' + contentlet.identifier),
                    close: !accordion.activeIds.includes('panel-' + contentlet.identifier)
                  }"
                ></i>
              </span>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div
              class="card-content"
              dotCmsSetAttributes
              [mode]="'full'"
              [fieldName]="'answer'"
              [identifier]="contentlet.identifier"
              [ishServerHtml]="contentlet.answer"
            ></div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </div>
  </div>
</ng-container>
